import { Listing } from '~/models'
import { cn } from '~/utils'

type BrokerNotesProps = {
  className?: string
  listing: Listing
}

export default function BrokerNotes(props: BrokerNotesProps) {
  const { className, listing } = props

  if (!listing.meta.notes) {
    return null
  }
  return (
    <div
      className={cn(
        className,
        'mt-1 text-base text-foreground prose max-w-none leading-7'
      )}
      dangerouslySetInnerHTML={{
        __html: [listing.meta.notes].filter((v) => v).join(''),
      }}></div>
  )
}
